@import 'styles/mixins';
@import 'styles/variables';

.sidebarResizeHandleContainer {
  position: absolute;
  height: 100%;
  z-index: 303;

  .sidebarResizeHandle {
    position: absolute;
    width: 6px;
    height: 100%;
    cursor: col-resize;
    z-index: 303;
    transition: background-color 0.2s ease-in;
    border-radius: 12px;

    &:hover,
    &.isResizing {
      background-color: var(--avatar);
    }
  }
}
